import { useState, useEffect } from 'react';

interface ResponsiveResult {
  isSmallMobile: boolean;
  isMobile: boolean;
  hasWideMargins: boolean;
  navHeight: number;
  width: Number | null;
}

const getResponsiveResult = (): ResponsiveResult => {
  let currentWidth = 2000;
  if (typeof window !== 'undefined' || typeof window !== 'undefined') {
    currentWidth = document.body.clientWidth || window.screen.availWidth;
  }

  const isSmallMobile = currentWidth <= 480;
  const isMobile = currentWidth <= 820;
  const hasWideMargins = currentWidth >= 640;

  return {
    isSmallMobile,
    isMobile,
    hasWideMargins,
    navHeight: isMobile ? 136 : 113,
    width: currentWidth,
  };
};

// TODO: This might be better implemented using an atom.
// It's currently used in a lot of places, so that useEffect is going to run a lot.
function useResponsive(): ResponsiveResult {
  const [result, setResult] = useState(getResponsiveResult());

  useEffect(() => {
    const handleResize = () => {
      setResult(getResponsiveResult());
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return result;
}

export default useResponsive;
